const doc = [({"zh_cn":({"adminConstantHotelMealType":({"all_meals":"含早餐/午餐/晚餐", "both":"含晚餐/早餐", "breakfast":"含早餐", "dinner":"含晚餐", "nothing":"不含"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;